(function(Search) {
    'use strict';

    Search.initSearchInline = function() {
        var $toggle = $('.js-search-toggle');
        var $target = $('.js-search-target');
        var $input = $target.find('.js-input');
        var $icon = $target.find('.js-search-icon-close');


        // Handlers

        $toggle.on('click', function(event) {
            event.preventDefault();

            $input.trigger('search:open');
            $input.trigger('search:addCLose');
        });

        $icon.on('click', function() {
            $input.trigger('search:clear');
            $input.trigger('search:close');
        });


        // Events

        $target.on('search:open', function() {
            $target.addClass('is-active');
            $input.focus();
        });

        $target.on('search:close', function() {
            $target.removeClass('is-active');
        });

        $target.on('search:clear', function() {
            $input.val('').focus();
            $input.trigger('search:removeClose');
        });
    };

})(window.Way2web.Search = window.Way2web.Search || {});
